module.exports = __webpack_public_path__ + "static/logo-wide-e52e2294fd4ea4c45301f0252141b4e0.png";